import CloseIcon from '@mui/icons-material/Close';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';

interface PointPopupProps {
  title: string;
  // category: string;
  // distance: number;
  status: string;
  schedule: string;
  address: string;
  openingHours: { day: string; hours: string }[];
  onClose: () => void;
}

const PointPopup: React.FC<PointPopupProps> = ({
  title,
  // category,
  // distance,
  status,
  schedule,
  address,
  openingHours,
  onClose,
}) => {
  const [showHours, setShowHours] = useState(false);
  const theme = useTheme();
  const today = new Date().toLocaleDateString('es-ES', { weekday: 'long' }).toLowerCase();

  return (
    <Box
      sx={{
        padding: 1,
        maxWidth: 300,
        maxHeight: 350,
        overflowY: 'scroll',
        '&::-webkit-scrollbar': {
          width: '5px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.primary.main,
          borderRadius: '10px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
      }}
    >
      <Stack sx={{ position: 'relative', direction: 'column', alignItems: 'start' }}>
        <Typography variant="body1" fontWeight={600} width="90%">
          {title}
        </Typography>
        {/* <Chip label={`${Math.round(distance)} m`} size="small" sx={{ margin: '0.3rem 0' }} /> */}
        <IconButton
          size="small"
          onClick={onClose}
          sx={{ position: 'absolute', top: '-0.3rem', right: '-0.5rem' }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>

      {/* <Typography variant="caption" color="text.secondary">
        {category}
      </Typography> */}

      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {status} • {schedule}
      </Typography>

      <Typography variant="body2" sx={{ mt: 1, fontWeight: 500 }}>
        {address}
      </Typography>

      <Divider sx={{ my: 1 }} />

      <Typography variant="caption" color="text.secondary">
        Sprint: <strong>Llévalo antes de las 16:00 hrs.</strong>
      </Typography>
      <Typography variant="caption" color="text.secondary" display="block">
        SameDay: <strong>Llévalo antes de las 14:00 hrs.</strong>
      </Typography>

      <Stack direction="row" spacing={1} mt={2} justifyContent="flex-start" alignItems="center">
        <Typography
          variant="caption"
          color={theme.palette.primary.main}
          sx={{ cursor: 'pointer' }}
          onClick={() => setShowHours((prev) => !prev)}
        >
          {showHours ? 'Ocultar horarios' : 'Mostrar horarios'}
        </Typography>
        <IconButton
          size="small"
          onClick={() => setShowHours((prev) => !prev)}
          sx={{ color: theme.palette.primary.main }}
        >
          {showHours ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Stack>

      <Collapse in={showHours}>
        <Typography variant="body1" fontWeight="500" mt={1}>
          Horarios del establecimiento
        </Typography>
        <List dense>
          {openingHours.map((item) => {
            const isToday = item.day.toLowerCase() === today;
            return (
              <ListItem
                key={item.day}
                sx={{
                  color: isToday ? theme.palette.primary.main : 'inherit',
                  fontWeight: isToday ? 600 : 400,
                  py: 0,
                  pl: 0,
                }}
              >
                <ListItemText
                  primary={`${item.day}: ${item.hours}`}
                  primaryTypographyProps={{ fontSize: 12 }}
                />
              </ListItem>
            );
          })}
        </List>
      </Collapse>
    </Box>
  );
};

export default PointPopup;
